// The maximum number of characters a clip sql can have.
export const sqlSizeLimit = 1024 * 1024

// Maximum result size (in bytes) that should be rendered.
export const resultSizeLimit = 25 * 1024 * 1024
